import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/merchant/doSure/login",
    method: "post",
    data: data
  });
}

export function fLogin(data) {
  return request({
    url: "/merchant/login",
    method: "post",
    data: data
  });
}
export function getInfo(data) {
  return request({
    url: "/merchant/getAgreementInfoById",
    method: "get",
    params: data
  });
}

// 获取验证码
export function loginCode(data) {
  return request({
    url: "/merchant/imageVerificationCode",
    method: "get",
    params: data
  });
}

export function logout() {
  return request({
    url: "/merchant/logoutNew",
    method: "post"
  });
}

export function getAgentOemDetail(data) {
  return request({
    url: "/merchant/common/getAgentOemDetail",
    method: "post",
    data: data
  });
}

// 获取当前用户菜单权限
export function getUserMenuPower() {
  return request({
    url: "/merchant/merchantMenu/getUserMenuPower",
    method: "get"
  });
}
// ai 弹框 参数获取
export function aiUserInfo(data) {
  return request({
    url: "/merchant/common/system/userInfo",
    method: "post",
    data: data
  });
}

//人脸提醒信息
export function UserInfoUpadte(data) {
  return request({
    url: "/merchant/common/system/userInfo/upadte",
    method: "post",
    data: data
  });
}
